import React from 'react';

import * as cn from 'classnames';
import PropTypes from 'prop-types';
import { IoClose } from 'react-icons/io5';

import { Text, Avatar, Indicator } from 'modules/common';

import * as c from './constants';

function Badge({
  label,
  variant,
  radius,
  type,
  leadingItem,
  avatarSrc,
  indicatorType,
  withLeading,
  withClose,
  onClose,
  leadingType,
  disabled,
  className,
  ...rest
}) {
  let $type = c.TYPE_OPTS({ variant });
  $type = disabled ? $type?.disabled : $type?.[type];

  const style = {
    background: $type?.background,
    text: $type?.text,
    border: c.VARIANT_OPTS?.({ type })?.[variant]?.border,
    radius: c.RADIUS_OPTS?.[radius],
    avatar: c.AVATAR_OPTS({ radius }),
    indicator:
      type === 'default'
        ? 'border border-transparent'
        : 'border border-primitive-white',
  };

  const renderLeading = {
    avatar: (
      <Avatar
        src={avatarSrc}
        size="16px"
        className="object-cover"
        radius={style.avatar.radius}
        style={style.avatar.style}
      />
    ),
    indicator: <Indicator className={style.indicator} type={indicatorType} />,
  };

  return (
    <div className="flex">
      <div
        className={cn(
          'flex items-center gap-x-ds-4 py-ds-2',
          style.background,
          style.text,
          style.border,
          style.radius,
          className
        )}
        {...rest}
      >
        {withLeading ? (
          <>{leadingItem || renderLeading?.[leadingType] || <div />}</>
        ) : (
          <div />
        )}

        <Text type="caption" weight="semibold">
          {label}
        </Text>

        {withClose ? (
          <div className="-mx-px">
            <IoClose
              className={cn('h-3.5 w-3.5', {
                'cursor-pointer ': !disabled,
              })}
              onClick={(e) => !disabled && onClose(e)}
            />
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
}

Badge.defaultProps = {
  variant: 'default',
  radius: 'default',
  type: 'default',
  indicatorType: 'default',
  leadingItem: false,
  withLeading: true,
  withClose: true,
  onClose: () => {},
  avatarSrc: '',
  leadingType: '',
  label: 'Badge',
  disabled: false,
  className: '',
};

Badge.propTypes = {
  withLeading: PropTypes.bool,
  avatarSrc: PropTypes.string,
  className: PropTypes.string,
  withClose: PropTypes.bool,
  onClose: PropTypes.instanceOf(Function),
  leadingItem: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.string,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
  label: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.string,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(Object.keys(c.VARIANT_OPTS())),
  radius: PropTypes.oneOf(Object.keys(c.RADIUS_OPTS)),
  type: PropTypes.oneOf(Object.keys(c.TYPE_OPTS())),
  indicatorType: PropTypes.oneOf(Object.keys(c.INDICATOR_TYPE_OPTS)),
  leadingType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf(c.LEADING_TYPE),
  ]),
};

export default Badge;
